import React, { useState, useEffect, useMemo } from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { SEO } from '../components/SEO';
import { StructuredData } from '../components/StructuredData';

const ReachUsPage = () => {
  const [isVisible, setIsVisible] = useState(false);

  // Scroll to top on component mount
  useEffect(() => {
    window.scrollTo(0, 0);
    // Trigger header animation
    const timer = setTimeout(() => setIsVisible(true), 300);
    return () => clearTimeout(timer);
  }, []);

  const structuredData = useMemo(() => ({
    "name": "Contact Savi Investing",
    "description": "Get in touch with Savi Investing for collaboration opportunities in value investing and long-term wealth creation.",
    "url": "https://saviinvesting.in/reach-us"
  }), []);

  return (
    <div className="min-h-screen flex flex-col">
      <SEO 
        title="Get in touch | Savi Investing"
        description="Drop us a line if our investing principles resonate with yours."
      />
      <StructuredData 
        type="ContactPage"
        data={structuredData}
      />
      <Header />
      
      <main className="flex-grow pt-24">
        {/* Page Header */}
        <section className="bg-[#29367A] text-white py-24">
          <div className="w-full max-w-7xl mx-auto px-8">
            <h1 
              className={`text-5xl font-bold text-center transition-all duration-1000 transform ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
              }`}
            >
              Reach Us
            </h1>
          </div>
        </section>

        {/* Contact Content */}
        <section className="py-16 bg-white">
          <div className="w-full max-w-7xl mx-auto px-8">
            <div className="grid md:grid-cols-2 gap-16 items-center">
              {/* Image - Left */}
              <div>
                <div className="relative rounded-2xl overflow-hidden shadow-2xl">
                  <img
                    src="https://images.unsplash.com/photo-1521791136064-7986c2920216?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHwxfHxidXNpbmVzcyUyMGhhbmRzaGFrZXxlbnwwfHx8fDE3NzU0MTMyMzZ8MA&ixlib=rb-4.1.0&q=85"
                    alt="Professional Collaboration"
                    className="w-full h-[600px] object-cover"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#29367A]/30 to-transparent"></div>
                </div>
              </div>

              {/* Text Content - Right */}
              <div>
                <p className="text-lg text-gray-700 leading-relaxed mb-8">
                  If you second our belief in the merits of long-term value investing, and would like to discuss potential collaborations, then get in touch with us.
                </p>

                <div className="space-y-4">
                  <h3 className="text-2xl font-bold text-gray-900 mb-4">
                    SAVI INVESTING PRIVATE LIMITED
                  </h3>
                  
                  <div className="text-gray-700 leading-relaxed space-y-3">
                    <p>
                      <span className="font-semibold">Corp. Office:</span><br />
                      Room 117, Gagananchal Shopping Complex,<br />
                      37 Dr. Abani Dutta Road,<br />
                      Howrah - 711106, WB, INDIA
                    </p>
                    
                    <p>
                      <span className="font-semibold">Regd. Office:</span><br />
                      Ganapati Apartments<br />
                      21 Kshetra Mitra Lane,<br />
                      Salkia,<br />
                      Howrah - 711106, WB, INDIA
                    </p>
                    
                    <p>
                      <span className="font-semibold">CIN:</span> U64990WB2025PTC281919
                    </p>
                    
                    <p>
                      <span className="font-semibold">Email:</span>{' '}
                      <a 
                        href="mailto:saviinvesting@gmail.com" 
                        className="text-[#29367A] hover:underline"
                      >
                        saviinvesting@gmail.com
                      </a>
                    </p>
                    
                    <p>
                      <span className="font-semibold">Ph:</span>{' '}
                      <a 
                        href="tel:+918240845206" 
                        className="text-[#29367A] hover:underline"
                      >
                        (91) 82408 45206
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default ReachUsPage;
